import { render, staticRenderFns } from "./KnowledgeButtonLine.vue?vue&type=template&id=fd95e042&"
import script from "./KnowledgeButtonLine.vue?vue&type=script&lang=js&"
export * from "./KnowledgeButtonLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports